import React, { useEffect } from "react";
import "./styles.scss";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import {
  setError,
  setInfo,
  setSuccess,
  useErrorSelector,
  useInfoSelector,
  useSuccessSelector
} from "../../../redux/actions/app";
import { useDispatch } from "react-redux";
import testsID from "../../../utils/TestsID";

export const CustomAlert = () => {
  const dispatch = useDispatch();

  const error = useErrorSelector();
  const success = useSuccessSelector();
  const info = useInfoSelector();

  useEffect(() => {
    if (error) {
      const interval = setTimeout(() => {
        dispatch(setError(""));
      }, 5000);
      return () => {
        clearTimeout(interval);
      };
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (success) {
      const interval = setTimeout(() => {
        dispatch(setSuccess(""));
      }, 3000);
      return () => {
        clearTimeout(interval);
      };
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (info) {
      const interval = setTimeout(() => {
        dispatch(setInfo(""));
      }, 3000);
      return () => {
        clearTimeout(interval);
      };
    }
  }, [info, dispatch]);

  const onRemoveError = () => {
    dispatch(setError(""));
  };

  const onRemoveSuccess = () => {
    dispatch(setSuccess(""));
  };

  const onRemoveInfo = () => {
    dispatch(setInfo(""));
  };

  return error || success || info ? (
    <div className="custom-alert">
      <Alert
        show={!!success}
        variant="success"
        className="custom-alert-success"
      >
        {success}
        {success && (
          <FontAwesomeIcon icon={faCircleXmark} onClick={onRemoveSuccess} />
        )}
      </Alert>
      <Alert
        id={testsID.ERROR_POPUP}
        show={!!error}
        variant="danger"
        className="custom-alert-error"
      >
        {error}
        {error && (
          <FontAwesomeIcon icon={faCircleXmark} onClick={onRemoveError} />
        )}
      </Alert>

      <Alert show={!!info} variant="info" className="custom-alert-info">
        {info}
        {info && (
          <FontAwesomeIcon icon={faCircleXmark} onClick={onRemoveInfo} />
        )}
      </Alert>
    </div>
  ) : (
    <></>
  );
};
